<mat-sidenav-container class="sidenav-container pimg1">
  <mat-sidenav
    #drawer
    class="sidenav"
    [ngClass]="{ hidden: !(isHandset$ | async) }"
    fixedInViewport="false"
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false"
  >
    <!---USUARIO NO IDENTIFICADO -->
    <mat-nav-list
      *ngIf="!identity"
      style="background-color: #c13030; color: seashell"
    >
      <mat-nav-list>
        <div class="context text-center">
          <p mat-list-item class="ml-3 lead"><mark>Iniciar Sesión</mark></p>
          <p class="text-white mt-2">{{ time | date: "mediumTime" }}</p>
          <p class="text-lead">
            <em>{{ msg }}</em>
          </p>
        </div>
      </mat-nav-list>
      <ul class="nav navbar-nav mt-5">
        <li class="nav-item list-group-item">
          <!--LOGIN-->
          <app-login></app-login>
        </li>
      </ul>
    </mat-nav-list>

    <!---USUARIO IDENTIFICADO -->
    <mat-nav-list *ngIf="identity">
      <mat-nav-list>
        <div class="row">
          <div class="user-panel">
            <div class="pull-left image">
              <img
                src="{{ identity.picture }}"
                class="rounded-circle elevation-3 ml-2"
                alt="User Image"
                width="85px"
              />
            </div>
            <div class="pull-left info">
              <p class="mt-2 text-white">
                <!-- NOMBRE CLIENTE  -->
                {{ identity.name + " " + identity.family_name }}
              </p>
              <ul class="nav navbar-nav">
                <li class="nav-item">
                  <a href="#" mat-list-item [routerLink]="['']"
                    ><i class="fa fa-circle text-success pr-1"></i> Online</a
                  >
                </li>
                <li class="nav-item">
                  <p class="text-white">
                    {{ time | date: "mediumTime" }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <ul class="nav navbar-nav">
          <li class="nav-item">
            <a
              mat-list-item
              [routerLinkActive]="['active']"
              [routerLink]="['servicios']"
              class="nav-link"
            >
              <mat-icon class="nav-mat-icon-link mr-2">devices_other</mat-icon>
              Servicios
            </a>
          </li>
          <li class="nav-item">
            <a
              mat-list-item
              [routerLinkActive]="['active']"
              [routerLink]="['equipo']"
              class="nav-link"
            >
              <mat-icon class="nav-mat-icon-link mr-2">groups</mat-icon>
              Equipo
            </a>
          </li>
          <li class="nav-item">
            <a
              mat-list-item
              [routerLinkActive]="['active']"
              [routerLink]="['contacto']"
              class="nav-link"
            >
              <mat-icon class="nav-mat-icon-link mr-2">contacts</mat-icon>
              Contacto
            </a>
          </li>
          <li class="nav-item">
            <a
              mat-list-item
              [routerLinkActive]="['active']"
              [routerLink]="['empresa']"
              class="nav-link"
            >
              <mat-icon class="nav-mat-icon-link mr-2">contacts</mat-icon>
              Sales
            </a>
          </li>
          <li class="nav-item">
            <a
              mat-list-item
              [routerLinkActive]="['active']"
              [routerLink]="['logout', 1]"
              class="nav-link"
            >
              <mat-icon class="nav-mat-icon-link pr-2">login</mat-icon>
              Salir
            </a>
          </li>
        </ul>
      </mat-nav-list>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar color="primary">
      <button
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="drawer.toggle()"
        *ngIf="isHandset$ | async"
      >
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <img src="../../assets/services/ilustrations/angular.png" width="85px" />
      <span>Angular</span>
      <span class="spacer"></span>
      <!---USUARIO NO IDENTIFICADO -->
      <mat-nav-list *ngIf="!identity"> </mat-nav-list>
      <!---USUARIO IDENTIFICADO (window:resize)="onResize($event)"-->
      <mat-nav-list *ngIf="identity">
        <ul style="display: flex; list-style: none">
          <li class="nav-item" *ngIf="windowSize.x > 962">
            <a class="nav-link" mat-menu-item [routerLink]="['empresa']">
              Sales
            </a>
          </li>
          <li class="nav-item" *ngIf="windowSize.x > 962">
            <a class="nav-link" mat-menu-item [routerLink]="['servicios']">
              Servicios
            </a>
          </li>
          <li class="nav-item" *ngIf="windowSize.x > 962">
            <a class="nav-link" mat-menu-item [routerLink]="['contacto']">
              Contacto
            </a>
          </li>
          <li class="nav-item" *ngIf="windowSize.x > 962">
            <a class="nav-link" mat-menu-item [routerLink]="['equipo']">
              Equipo
            </a>
          </li>
          <li>
            <a
              mat-list-item
              [routerLink]="['']"
              style="color: white; font-size: small"
            >
              <p class="text-white mt-3" *ngIf="windowSize.x > 480">
                {{ identity.name + " " }}
              </p>
              <p class="text-white mt-3 ml-1" *ngIf="windowSize.x > 780">
                {{ " " + identity.family_name }}
              </p>
              <img
                src="{{ identity.picture }}"
                width="35px"
                alt="{{ identity.name }}"
                class="rounded img-circle elevation-3 ml-3"
                style="opacity: 0.8"
            /></a>
          </li>
          <li *ngIf="windowSize.x > 962">
            <button
              mat-icon-button
              [matMenuTriggerFor]="menu"
              aria-label="Example icon-button with a menu"
            >
              <mat-icon>more_vert</mat-icon>
            </button>

            <mat-menu #menu="matMenu">
              <ul class="list-group">
                <li class="list-group-item menulist">
                  <a mat-menu-item [routerLink]="['logout', 1]">
                    <mat-icon class="nav-mat-icon-link text-white pr-2"
                      >login</mat-icon
                    >
                    Salír
                  </a>
                </li>
              </ul>
            </mat-menu>
          </li>
        </ul>
      </mat-nav-list>
    </mat-toolbar>
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
